import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=46c54cae&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=46c54cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c54cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c54cae')) {
      api.createRecord('46c54cae', component.options)
    } else {
      api.reload('46c54cae', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=46c54cae&scoped=true&", function () {
      api.rerender('46c54cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22zbNVIe4Td3E/JS/comp/DocBox.vue"
export default component.exports